import React from "react";
import FormFeedback from "../Global/Form/FormFeedback";

const FooterFeedback: React.FC = () => {
    return (
        <>
            <FormFeedback className="formFeedback"/>
        </>
    )
}
export default FooterFeedback;